/**
 * an object to set elements having a given selector to the same height
 * it's responsive
 * @todo implement option to choose property to reach the same height (margin, padding) for each selector
 * @see https://gitlab.com/orange-yc/samariter-inside.de/blob/master/htdocs/oyc-content/themes/oyCeme/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/libs/EqualProperty.js
 */
oyc.EqualHeight = {
  selector: {
    init: [
      '.process .process-text',
      '.process .process-top h3',
      '.subcompany .subcompany-text h3',
      '.subcompany .image-figure',
      '.is-slider .cards .cards-media',
      '.media-gallery .media-gallery-media'
    ]
  },
  maxHeight: 0,
  items: [],
  /**
   *
   * @param {array} selector an array containing selectors for dom elements
   * @returns {undefined}
   */
  init: function (selector) {
    let $this = oyc.EqualHeight;
    if (typeof selector !== 'undefined') {
      $this.selector.init = selector;
    }
    $this.equalize();
    $(window).on('resize', $this.equalize);
  },
  /**
   * here all seelctors are walked through calling functions to calc the height and setting it afterwards
   * @returns {undefined}
   */
  equalize: function () {
    let $this = oyc.EqualHeight;
    for (let selector in $this.selector.init) {
      if($this.selector.init.hasOwnProperty(selector)) {
        let items = $($this.selector.init[selector]);
        if (items.length > 1) {
          $this.items[selector] = items.css('height', 'auto');
          $this.calcHeight(selector);
          $this.setHeight(selector);
        }
      }
    }
  },
  /**
   * walking through the elements of a selector given as parameter, setting member maxHeight
   * @param {string} selector
   * @returns {undefined}
   */
  calcHeight: function (selector) {
    var maxHeight = 0;
    this.items[selector].each(function (i, item) {
      var height = $(item).height();
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    this.maxHeight = maxHeight;
  },
  /**
   * setting the height of each element of a selector
   * @param {string} selector
   * @returns {undefined}
   */
  setHeight: function (selector) {
    var maxHeight = this.maxHeight;
    this.items[selector].each(function (i, item) {
      $(item).height(maxHeight);
    })
  },
  /**
   * function to push a selector to watch for euqualization
   * @param {type} selector
   * @returns {undefined}
   */
  addSelector: function (selector) {
    if ($(selector).length > 0) {
      oyc.EqualHeight.selector.init.push(selector);
    }
  }

}
